import { FunctionComponent, ReactElement, SVGProps } from "react";
import assetsConfig from "./assetsConfig";
import { DefaultTheme } from "styled-components";

let config: Config = {
	assets: assetsConfig,
};

export default config!;

export interface Config {
	assets: AssetsConfig;
}

export interface Logos {
	local: SvgIcon;
	localPng: string;
	primary: string;
	primaryWhite: string;
	secondary: string;
}

export interface Loading {
	primary: string;
	secondary: string;
	tertiary: string;
	quaternary: string;
}

export interface Backgrounds {
	primary: FunctionComponent<
		SVGProps<SVGSVGElement> & { title?: string | undefined }
	>;
}

export interface Placeholders {
	// user: string;
	// company: string;
	image: string;
	imageBackground: string;
}

export interface FontFace {
	src: string;
	fontWeight: number;
	fontStyle?: "normal" | "italic" | "oblique";
}

export interface Font {
	fontFamily: string;
	fontFallback?: string;
	// src accepts either
	// (1) a google fonts url that has the font faces defined
	// (2) an array of FontFace objects for local font files
	fontSrc: string | FontFace[];
}
export interface Fonts {
	pdf: {
		activeFont: "default" | "primary";
		default: {
			fontFamily: string;
			fontSrc: FontFace[];
		};
		primary: {
			fontFamily: string;
			fontSrc: FontFace[];
		};
		currency: {
			fontFamily: string;
			fontSrc: FontFace[];
		};
	};
}

export interface UserScript {
	src: string;
	loadFirst?: boolean; // load this script first (for auto-blocking scripts)
	id?: string;
	async?: boolean;
	defer?: boolean;
	crossOrigin?: string;
	[key: string]: string | boolean | undefined;
}

type SvgIcon = ReactElement;
export interface AssetsConfig {
	companyName: string;
	companyNameShort: string;
	companyNameLong: string;
	holdingCompanyName: string;
	agencyNetworkCompanyName: string;
	logos: Logos;
	icons: {
		[iconName: string]: SvgIcon;
	};
	loading: Loading;
	backgrounds: Backgrounds;
	placeholders: Placeholders;
	fonts: Fonts;
	urls: { [key: string]: string };
	colors: DefaultTheme;
	settings: {
		showHelpWidget: boolean;
	};
	scripts: UserScript[];
}
